import React, { useState, useEffect } from "react";
import { getCurrentDate } from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import axios from "axios";

const PPLostTrainUpdate = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const currentDate = getCurrentDate();
  const [PPLostData, setPPLostData] = useState([]);

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [globalDate, setGlobalDate] = useState(currentDate);
  const [show, setShow] = useState(false);

  const [gridData, setGridData] = useState([]);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getpplostdata?date=${globalDate}`
      );
      if (response.data.status === "ok") {
        setPPLostData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [globalDate]);
  const columnHead = [
    "SCH_DATE",
    "TRAIN_NO",
    "START_DATE",
    "TRAIN_TYPE",
    "OWNG_RLY",
    "RPT_SOURCE",
    "Status",
    "Status_TIME",
    "DIVI",
    "INCIDENT_SECTION",
    "LOC_FROM",
    "LOC_TO",
    "DET_TYPE",
    "DET_CODE",
    "SUB_CODE",
    "REMARKS",
  ];

  useEffect(() => {
    const filtered = (PPLostData || []).filter(
      (row) => row.SCH_DATE && String(row.SCH_DATE).slice(0, 10) === globalDate
    );
    setGridData(filtered);
  }, [PPLostData, globalDate]);

  const handleChange = (rowIndex, key, value) => {
    const newData = [...gridData];
    newData[rowIndex][key] = value;
    setGridData(newData);
  };

  const sendToBackend = async () => {
    const finalData = gridData.map(
      ({
        SCH_DATE,
        START_DATE,
        insdate,

        ...rest
      }) => rest
    );
    try {
      const response = await fetch(`${urlPrefix}pplosttrainupdate`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ records: finalData }),
      });
      if (!response.ok) {
        alert("Something went wrong");
        throw new Error("Network response was not ok");
      }

      await response.json();
      alert("success");
      setGlobalDate(new Date().toISOString().slice(0, 10));
    } catch (err) {
      console.error("Submission error:", err);
      setError(true);
    }
  };

  return (
    <div className="text-center mt-12">
      <div className="papaDiv text-start ms-3 me-3">
        <h4 className="ms-4">
          <MdInsertChart /> pp Lost train
        </h4>
        <h5 className="ps-2">
          Update data in table <b style={{ color: "red" }}>"pp_lost_train"</b>
        </h5>
      </div>

      <div className="my-3">
        Select Date:{" "}
        <input
          type="date"
          value={globalDate}
          max={currentDate}
          onChange={(e) => setGlobalDate(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table
          className="table table-striped table-hover"
          border="1"
          cellPadding="1"
        >
          <thead>
            <tr className="table-dark" style={{ fontSize: "12px" }}>
              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columnHead.map((col, colIndex) => (
                  <td key={colIndex} style={{ border: "1px solid gray" }}>
                    {col === "SCH_DATE" || col === "START_DATE" ? (
                      <input
                        disabled
                        type="date"
                        value={
                          row[col]?.slice(0, 10) || globalDate?.slice(0, 10)
                        }
                        max={currentDate}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : col === "REMARKS" ? (
                      <textarea
                        value={row[col] || ""}
                        style={{ width: "300px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        value={row[col] || ""}
                        style={{ width: "80px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, col, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="p-3">
        {result?.insertion ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>

      <div>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default PPLostTrainUpdate;
